export default {"src":"/_next/static/media/scalpel_24.55e4f7bc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};